// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { reference } from '@angular/core/src/render3';
import { GetPhotosWitPoductGroupsViewModel } from '../models/Product.model';
import { Offer } from '../models/offer.model';

@Injectable()
export class AccountEndpoint extends EndpointFactory {

  private readonly _usersUrl: string = "/api/account/users";
  private readonly _userByUserNameUrl: string = "/api/account/users/username";
  private readonly _currentUserUrl: string = "/api/account/users/me";
  private readonly _currentUserPreferencesUrl: string = "/api/account/users/me/preferences";
  private readonly _unblockUserUrl: string = "/api/account/users/unblock";
  private readonly _rolesUrl: string = "/api/account/roles";
  private readonly _roleByRoleNameUrl: string = "/api/account/roles/name";
  private readonly _permissionsUrl: string = "/api/account/permissions";
  private readonly _contulMeuUrl: string = "/api/account/contulMeu";
  private readonly _contulMeuListUrl: string = "/api/account/contulMeuList";
  private readonly _aprobareContulMeuUrl: string = "/api/account/aprobareContulMeu";
  private readonly _companieUrl: string = "/api/account/companie";
  private readonly _companiiReprezentateUrl: string = "/api/account/companiiReprezentate";
  private readonly _companiiReprezentateAutocompleteUrl: string = "/api/account/companiiReprezentateAutocomplete";
  private readonly _aprobarereprezentareCompanie: string = "/api/account/aprobarereprezentareCompanie";
  private readonly _selectieCompanie: string = "/api/account/selectieCompanie";
  private readonly _getCompanieSelectata: string = "/api/account/getCompanieSelectata";
  private readonly _usersFromOutsideUrl: string = "/api/accountFromOutside/usersFromOutside";
  private readonly _sendMailForPasswordRecoveryUrl: string = "/api/accountFromOutside/sendMailForPasswordRecovery";
  private readonly _confirmUserUrl: string = "/api/accountFromOutside/confirmUser";
  private readonly _getCompaniiUrl: string = "/api/accountFromOutside/getCompanii";
  private readonly _uploadFilesUrl: string = "/api/files/uploadFiles";
  private readonly _uploadPriceFilesUrl: string = "/api/files/uploadPriceFiles";
  private readonly _getDownloadFileUrl: string = "/api/account/download";
  private readonly _getDownloadOfferFileUrl: string = "/api/account/downloadOffer";
  private readonly _uploadDocumentCiUrl: string = "/api/files/uploadDocumentCiUrl";
  private readonly _getDownloadFileCIUrl: string = "/api/account/downloadCI";
  private readonly _uploadDocumentCompanieUrl: string = "/api/files/uploadDocumentCompanie";
  private readonly _getDownloadDocumentCompanieUrl: string = "/api/account/downloadDocumentCompanie";
  private readonly _deleteCompanyUrl: string = "/api/account/deleteCompany";

  private readonly _carsUrl: string = "/api/account/cars";
  private readonly _carsConfiguratorUrl: string = "/api/account/carsConfigurator";
  private readonly _productUrl: string = "/api/account/products";
  private readonly _productConfiguratorUrl: string = "/api/account/productConfigurator";
  private readonly _catalogLinkUrl: string = "/api/account/catalogLinks";
  private readonly _catalogLinkConfiguratorUrl: string = "/api/account/catalogLinkConfigurator";
  private readonly _offerUrl: string = "/api/account/offer";
  private readonly _offerConfiguratorUrl: string = "/api/account/offerConfigurator";
  private readonly _pozeUrl: string = "/api/account/photos";
  private readonly _getPhotosWitPoductGroupsViewModel: string = "/api/account/getPhotosWitPoductGroupsViewModel";
  private readonly _updatePhotoUrl: string = "/api/account/updatePhoto";
  private readonly _pozeConfiguratorUrl: string = "/api/account/pozeConfigurator";
  private readonly _offerListProductPhotoUrl: string = "/api/account/offerListProductPhoto";
  private readonly _auditLoginListUrl: string = "/api/account/auditLoginList";
  private readonly _cloneOfferUrl: string = "/api/account/cloneOffer";

  get usersUrl() { return this.configurations.baseUrl + this._usersUrl; }
  get userByUserNameUrl() { return this.configurations.baseUrl + this._userByUserNameUrl; }
  get currentUserUrl() { return this.configurations.baseUrl + this._currentUserUrl; }
  get currentUserPreferencesUrl() { return this.configurations.baseUrl + this._currentUserPreferencesUrl; }
  get unblockUserUrl() { return this.configurations.baseUrl + this._unblockUserUrl; }
  get rolesUrl() { return this.configurations.baseUrl + this._rolesUrl; }
  get roleByRoleNameUrl() { return this.configurations.baseUrl + this._roleByRoleNameUrl; }
  get permissionsUrl() { return this.configurations.baseUrl + this._permissionsUrl; }
  get contulMeuUrl() { return this.configurations.baseUrl + this._contulMeuUrl; }
  get contulMeuListUrl() { return this.configurations.baseUrl + this._contulMeuListUrl; }
  get aprobareContulMeu() { return this.configurations.baseUrl + this._aprobareContulMeuUrl; }
  get companieUrl() { return this.configurations.baseUrl + this._companieUrl; }
  get companiiReprezentateUrl() { return this.configurations.baseUrl + this._companiiReprezentateUrl; }
  get companiiReprezentateAutocompleteUrl() { return this.configurations.baseUrl + this._companiiReprezentateAutocompleteUrl; } 
  get aprobarereprezentareCompanie() { return this.configurations.baseUrl + this._aprobarereprezentareCompanie; }
  get selectieCompanie() { return this.configurations.baseUrl + this._selectieCompanie; }
  get getCompanieSelectata() { return this.configurations.baseUrl + this._getCompanieSelectata; }
  get usersFromOutsideUrl() { return this.configurations.baseUrl + this._usersFromOutsideUrl; }
  get sendMailForPasswordRecoveryUrl() { return this.configurations.baseUrl + this._sendMailForPasswordRecoveryUrl; }
  get confirmUserUrl() { return this.configurations.baseUrl + this._confirmUserUrl; }
  get getCompaniiUrl() { return this.configurations.baseUrl + this._getCompaniiUrl; }
  get uploadFilesUrl() { return this.configurations.baseUrl + this._uploadFilesUrl; }
  get uploadPriceFilesUrl() { return this.configurations.baseUrl + this._uploadPriceFilesUrl; }
  get getDownloadFileUrl() { return this.configurations.baseUrl + this._getDownloadFileUrl; }
  get getDownloadOfferFileUrl() { return this.configurations.baseUrl + this._getDownloadOfferFileUrl; }
  get uploadDocumentCiUrl() { return this.configurations.baseUrl + this._uploadDocumentCiUrl; }
  get getDownloadFileCIUrl() { return this.configurations.baseUrl + this._getDownloadFileCIUrl; }
  get uploadDocumentCompanieUrl() { return this.configurations.baseUrl + this._uploadDocumentCompanieUrl; }
  get getDownloadDocumentCompanieUrl() { return this.configurations.baseUrl + this._getDownloadDocumentCompanieUrl; }
  get deleteCompanyUrl() { return this.configurations.baseUrl + this._deleteCompanyUrl; }

  //
  get carsUrl() { return this.configurations.baseUrl + this._carsUrl; }
  get carsConfiguratorUrl() { return this.configurations.baseUrl + this._carsConfiguratorUrl; }
  get productUrl() { return this.configurations.baseUrl + this._productUrl; }
  get productConfiguratorUrl() { return this.configurations.baseUrl + this._productConfiguratorUrl; }
  get catalogLinkUrl() { return this.configurations.baseUrl + this._catalogLinkUrl; }
  get catalogLinkConfiguratorUrl() { return this.configurations.baseUrl + this._catalogLinkConfiguratorUrl; }
  get offerUrl() { return this.configurations.baseUrl + this._offerUrl; }
  //get updateOfferUrl() { return this.configurations.baseUrl + this.updateOfferUrl; }
  get offerConfiguratorUrl() { return this.configurations.baseUrl + this._offerConfiguratorUrl; }
  get pozeUrl() { return this.configurations.baseUrl + this._pozeUrl; }
  get getPhotosWitPoductGroupsViewModel() { return this.configurations.baseUrl + this._getPhotosWitPoductGroupsViewModel; }
  get updatePhotoUrl() { return this.configurations.baseUrl + this._updatePhotoUrl; }
  get pozeConfiguratorUrl() { return this.configurations.baseUrl + this._pozeConfiguratorUrl; }
  get offerListProductPhotoUrl() { return this.configurations.baseUrl + this._offerListProductPhotoUrl; }
  get auditLoginListUrl() { return this.configurations.baseUrl + this._auditLoginListUrl; }
  get cloneOfferUrl() { return this.configurations.baseUrl + this._cloneOfferUrl; }

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {

    super(http, configurations, injector);
  }

  getUserEndpoint<T>(userId?: string): Observable<T> {
    let endpointUrl = userId ? `${this.usersUrl}/${userId}` : this.currentUserUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserEndpoint(userId));
      }));
  }

  getUserByUserNameEndpoint<T>(userName: string): Observable<T> {
    let endpointUrl = `${this.userByUserNameUrl}/${userName}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserByUserNameEndpoint(userName));
      }));
  }

  getUsersEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    let endpointUrl = page && pageSize ? `${this.usersUrl}/${page}/${pageSize}` : this.usersUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUsersEndpoint(page, pageSize));
      }));
  }

  getNewUserEndpoint<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.usersUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewUserEndpoint(userObject));
      }));
  }

  confirmUserEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.confirmUserUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.confirmUserEndpoint(userObject));
      }));
  }
  
  getNewUserFromOutsideEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.usersFromOutsideUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewUserFromOutsideEndpoint(userObject));
      }));
  }

  sendMailForPasswordRecoveryEndpoint<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.sendMailForPasswordRecoveryUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.sendMailForPasswordRecoveryEndpoint(userObject));
      }));
  }

  getUpdateUserEndpoint<T>(userObject: any, userId?: string): Observable<T> {
    let endpointUrl = userId ? `${this.usersUrl}/${userId}` : this.currentUserUrl;

    return this.http.put<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUpdateUserEndpoint(userObject, userId));
      }));
  }

  getPatchUpdateUserEndpoint<T>(patch: {}, userId?: string): Observable<T>
  getPatchUpdateUserEndpoint<T>(value: any, op: string, path: string, from?: any, userId?: string): Observable<T>
  getPatchUpdateUserEndpoint<T>(valueOrPatch: any, opOrUserId?: string, path?: string, from?: any, userId?: string): Observable<T> {
    let endpointUrl: string;
    let patchDocument: {};

    if (path) {
      endpointUrl = userId ? `${this.usersUrl}/${userId}` : this.currentUserUrl;
      patchDocument = from ?
        [{ "value": valueOrPatch, "path": path, "op": opOrUserId, "from": from }] :
        [{ "value": valueOrPatch, "path": path, "op": opOrUserId }];
    }
    else {
      endpointUrl = opOrUserId ? `${this.usersUrl}/${opOrUserId}` : this.currentUserUrl;
      patchDocument = valueOrPatch;
    }

    return this.http.patch<T>(endpointUrl, JSON.stringify(patchDocument), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getPatchUpdateUserEndpoint(valueOrPatch, opOrUserId, path, from, userId));
      }));
  }

  getUserPreferencesEndpoint<T>(): Observable<T> {

    return this.http.get<T>(this.currentUserPreferencesUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserPreferencesEndpoint());
      }));
  }

  getUpdateUserPreferencesEndpoint<T>(configuration: string): Observable<T> {
    return this.http.put<T>(this.currentUserPreferencesUrl, JSON.stringify(configuration), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUpdateUserPreferencesEndpoint(configuration));
      }));
  }

  getUnblockUserEndpoint<T>(userId: string): Observable<T> {
    let endpointUrl = `${this.unblockUserUrl}/${userId}`;

    return this.http.put<T>(endpointUrl, null, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUnblockUserEndpoint(userId));
      }));
  }

  getDeleteUserEndpoint<T>(userId: string): Observable<T> {
    let endpointUrl = `${this.usersUrl}/${userId}`;

    return this.http.delete<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDeleteUserEndpoint(userId));
      }));
  }

  getRoleEndpoint<T>(roleId: string): Observable<T> {
    let endpointUrl = `${this.rolesUrl}/${roleId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRoleEndpoint(roleId));
      }));
  }

  getRoleByRoleNameEndpoint<T>(roleName: string): Observable<T> {
    let endpointUrl = `${this.roleByRoleNameUrl}/${roleName}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRoleByRoleNameEndpoint(roleName));
      }));
  }

  getRolesEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    let endpointUrl = page && pageSize ? `${this.rolesUrl}/${page}/${pageSize}` : this.rolesUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRolesEndpoint(page, pageSize));
      }));
  }

  getNewRoleEndpoint<T>(roleObject: any): Observable<T> {

    return this.http.post<T>(this.rolesUrl, JSON.stringify(roleObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewRoleEndpoint(roleObject));
      }));
  }

  getUpdateRoleEndpoint<T>(roleObject: any, roleId: string): Observable<T> {
    let endpointUrl = `${this.rolesUrl}/${roleId}`;

    return this.http.put<T>(endpointUrl, JSON.stringify(roleObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUpdateRoleEndpoint(roleObject, roleId));
      }));
  }

  getDeleteRoleEndpoint<T>(roleId: string): Observable<T> {
    let endpointUrl = `${this.rolesUrl}/${roleId}`;

    return this.http.delete<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDeleteRoleEndpoint(roleId));
      }));
  }

  getPermissionsEndpoint<T>(): Observable<T> {

    return this.http.get<T>(this.permissionsUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getPermissionsEndpoint());
      }));
  }

  getNewContulMeuEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.contulMeuUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewContulMeuEndpoint(userObject));
      }));
  }

  getNewPozeEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.pozeUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewPozeEndpoint(userObject));
      }));
  }

  getUserContulMeuEndpoint<T>(userId?: string): Observable<T> {
    let endpointUrl = userId ? `${this.contulMeuUrl}/${userId}` : `${this.contulMeuUrl}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserContulMeuEndpoint(userId));
      }));
  }

  getUserPozeEndpoint<T>(userId?: string): Observable<T> {
    let endpointUrl = userId ? `${this.pozeUrl}/${userId}` : `${this.pozeUrl}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserPozeEndpoint(userId));
      }));
  }

  getContulMeuListEndpoint<T>(nume?: string, prenume?: string, document?: string): Observable<T> {
    let endpointUrl = `${this.contulMeuListUrl}/${nume}&${prenume}&${document}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getContulMeuListEndpoint(nume, prenume, document));
      }));
  }

  getAprobareContulMeuEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.aprobareContulMeu, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getAprobareContulMeuEndpoint(userObject));
      }));
  }

  getNewCompanieEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.companieUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewCompanieEndpoint(userObject));
      }));
  }
  
  getCompaniiReprezentateAutocompleteListEndpoint<T>(denumire?: string, cif?: string, all?: string): Observable<T> {
    let endpointUrl = `${this.companiiReprezentateAutocompleteUrl}/${denumire}&${cif}&${all}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCompaniiReprezentateAutocompleteListEndpoint(denumire, cif, all));
      }));
  }
  
  getCompaniiReprezentateListEndpoint<T>(denumire?: string, cif?: string, all?: string): Observable<T> {
    let endpointUrl = `${this.companiiReprezentateUrl}/${denumire}&${cif}&${all}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCompaniiReprezentateListEndpoint(denumire, cif, all));
      }));
  }
  
  aprobareReprezentareCompanieEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.aprobarereprezentareCompanie, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.aprobareReprezentareCompanieEndpoint(userObject));
      }));
  }

  selectieCompanieEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.selectieCompanie, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.selectieCompanieEndpoint(userObject));
      }));
  }

  getCompanieSelectataEndpoint<T>(): Observable<T> {
    let endpointUrl = this.getCompanieSelectata;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCompanieSelectataEndpoint());
      }));
  }
  
  getCompaniiListForAutocompleteEndpoint<T>(denumire?: string, cif?: string, all?: string): Observable<T> {
    let endpointUrl = `${this.getCompaniiUrl}/${denumire}&${cif}&${all}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCompaniiListForAutocompleteEndpoint(denumire, cif, all));
      }));
  }
  
  downloadDocEndpoint<T>(filename?: string): Observable<T> {
    let endpointUrl = `${this.getDownloadFileUrl}/${filename}`;
    
    return this.http.get<T>(
      endpointUrl,
      this.getRequestDownloadFileHeaders(),
      ).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.downloadDocEndpoint());
      }));
  }
  
  downloadOfferEndpoint<T>(tip_export: string, filename?: string, browserLang?: string): Observable<T> {
    let endpointUrl = `${this.getDownloadOfferFileUrl}/${tip_export}&${filename}&${browserLang}`;
    
    return this.http.get<T>(
      endpointUrl,
      this.getRequestDownloadFileHeaders(),
    ).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.downloadOfferEndpoint(tip_export));
      }));
  }

  uploadEndpoint<T>(tipIncarcare: string, file: any): Observable<T> {
    return this.http.post<T>(`${this.uploadFilesUrl}/${tipIncarcare}`, file, this.getRequestHeadersFileUpload()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadEndpoint(tipIncarcare, file));
      }));
  }

  uploadPriceEndpoint<T>(tipIncarcare: string, file: any): Observable<T> {
    return this.http.post<T>(`${this.uploadPriceFilesUrl}/${tipIncarcare}`, file, this.getRequestHeadersFileUpload()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadPriceEndpoint(tipIncarcare, file));
      }));
  }
  
  uploadFisierDocumentCIEndpoint<T>(idDetaliu: string, file: any): Observable<T> {
    return this.http.post<T>(`${this.uploadDocumentCiUrl}/${idDetaliu}`, file, this.getRequestHeadersFileUpload()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadFisierDocumentCIEndpoint(idDetaliu, file));
      }));
  }

  downloadDocCIEndpoint<T>(filename?: string): Observable<T> {
    let endpointUrl = `${this.getDownloadFileCIUrl}/${filename}`;

    return this.http.get<T>(
      endpointUrl,
      this.getRequestDownloadFileHeaders(),
    ).pipe<T>(
      catchError(error => {
      return this.handleError(error, () => this.downloadDocCIEndpoint());
      }));
  }
  
  downloadDocumentCompanieEndpoint<T>(idReprezentant: string, idCompanie: string, mod: string): Observable<T> {
    let endpointUrl = `${this._getDownloadDocumentCompanieUrl}/${idReprezentant}/${idCompanie}/${mod}`;

    return this.http.get<T>(
      endpointUrl,
      this.getRequestDownloadFileHeaders(),
    ).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.downloadDocumentCompanieEndpoint(idReprezentant, idCompanie, mod));
      }));
  }

  uploadFisierDocumentCompanieEndpoint<T>(idReprezentant: string, idCompanie: string, file: any, mod: string): Observable<T> {
    return this.http.post<T>(`${this.uploadDocumentCompanieUrl}/${idReprezentant}/${idCompanie}/${mod}`, file, this.getRequestHeadersFileUpload()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadFisierDocumentCompanieEndpoint(idReprezentant, idCompanie, file, mod));
      }));
  }

  getCarsListEndpoint<T>(make?: string, model?: string): Observable<T> {
    let endpointUrl = `${this.carsUrl}/${make}&${model}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCarsListEndpoint(make, model));
      }));
  }

  getCarsConfiguratorListEndpoint<T>(make?: string, model?: string, body?: string, variant?: string, wheelbase?: string, height?: string, transmission?: string, reference?: string): Observable<T> {
    let endpointUrl = `${this.carsConfiguratorUrl}/${make}&${model}&${body}&${variant}&${reference}&${wheelbase}&${height}&${transmission}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCarsConfiguratorListEndpoint(make, model, body, variant, wheelbase, height, transmission, reference));
      }));
  }

  getProductListEndpoint<T>(reference?: string, description?: string, carReference?: string, pricedealer?: string, pricefinalcustomer?: string, descriptionfr?: string, productgrup?: string, VehicleReference?: string, descriptionro?: string, productnumber?: string, catalogreference?: string, linkCatalog?: string, descriptionen?: string, carSelect?: string): Observable<T> {
    let endpointUrl = `${this.productUrl}/${reference}&${description}&${carReference}&${pricedealer}&${pricefinalcustomer}&${descriptionfr}&${productgrup}&${VehicleReference}&${descriptionro}&${productnumber}&${catalogreference}&${linkCatalog}&${descriptionen}&${carSelect}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getProductListEndpoint(reference, description, carReference, pricedealer, pricefinalcustomer, descriptionfr, productgrup, VehicleReference, descriptionro, productnumber, catalogreference, linkCatalog, descriptionen, carSelect));
      }));
  }

  getProductConfiguratorListEndpoint<T>(reference?: string, description?: string, pricedealer?: string, pricefinalcustomer?: string, productgrup?: string): Observable<T> {
    let endpointUrl = `${this.productConfiguratorUrl}/${reference}&${description}&${pricedealer}&${pricefinalcustomer}&${productgrup}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getProductConfiguratorListEndpoint(reference, description, pricedealer, pricefinalcustomer, productgrup));
      }));
  }

  getCatalogLinkListEndpoint<T>(catalogreference?: string): Observable<T> {
    let endpointUrl = `${this.catalogLinkUrl}/${catalogreference}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCatalogLinkListEndpoint(catalogreference));
      }));
  }

  getCatalogLinkConfiguratorListEndpoint<T>(): Observable<T> {
    let endpointUrl = `${this.catalogLinkConfiguratorUrl}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCatalogLinkConfiguratorListEndpoint());
      }));
  }

  getPozeListEndpoint<T>(ProductGroup?: string, VehicleReference?: string, PhotoReference?: string, carReference?: string, productGrup?: string): Observable<T> {
    let endpointUrl = `${this.pozeUrl}/${ProductGroup}&${VehicleReference}&${PhotoReference}&${carReference}&${productGrup}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getPozeListEndpoint(ProductGroup, VehicleReference, PhotoReference, carReference, productGrup));
      }));
  }

  getPhotosWitPoductGroupsViewModelEndpoint<T>(getPhotosWitPoductGroupsViewModel?: GetPhotosWitPoductGroupsViewModel): Observable<T> {
    let endpointUrl = `${this.getPhotosWitPoductGroupsViewModel}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(getPhotosWitPoductGroupsViewModel), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getPhotosWitPoductGroupsViewModelEndpoint(getPhotosWitPoductGroupsViewModel));
      }));
  }

  getPozeConfiguratorListEndpoint<T>(ProductGroup?: string, VehicleReference?: string, PhotoReference?: string): Observable<T> {
    let endpointUrl = `${this.pozeConfiguratorUrl}/${ProductGroup}&${VehicleReference}&${PhotoReference}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getPozeConfiguratorListEndpoint(ProductGroup, VehicleReference, PhotoReference));
      }));
  }

  getOfferListEndpoint<T>(id: string, subject: string, initialDate: string, finalDate: string): Observable<T> {
    let endpointUrl = `${this.offerUrl}/${id}&${subject}&${initialDate}&${finalDate}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getOfferListEndpoint(id, subject, initialDate, finalDate));
      }));
  }

  getOfferConfiguratorListEndpoint<T>(CarId?: string, usergenerare?: string, model?: string, body?: string, variant?: string, reference?: string): Observable<T> {
    let endpointUrl = `${this.offerConfiguratorUrl}/${usergenerare}&${CarId}&${model}&${body}&${variant}&${reference}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getOfferConfiguratorListEndpoint(CarId, usergenerare, model, body, variant, reference));
      }));
  }

  saveCarEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.carsUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.saveCarEndpoint(userObject));
      }));
  }

  saveProductEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.productUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.saveProductEndpoint(userObject));
      }));
  }

  saveCatalogLinkEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.catalogLinkUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.saveCatalogLinkEndpoint(userObject));
      }));
  }

  saveOfferEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.offerUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.saveOfferEndpoint(userObject));
      }));
  }

  saveOfferManualDetailsEndpoint<T>(offerId: string, manualRows: any): Observable<T> {
    let endpointUrl = `${this.configurations.baseUrl}/api/account/offerManualDetails/${offerId}`;
    return this.http.post<T>(endpointUrl, JSON.stringify(manualRows), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.saveOfferManualDetailsEndpoint(offerId, manualRows));
      }));
  }

  savePozeEndpoint<T>(pozaObject: any): Observable<T> {
    return this.http.post<T>(this.updatePhotoUrl, JSON.stringify(pozaObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.savePozeEndpoint(pozaObject));
      }));
  }

  uploadPhotoEndpoint<T>(productGroup: string, vehicleReference: string, photoReference: string, file: any): Observable<T> {
    let url = this.configurations.baseUrl + '/api/account/uploadPhoto/' + productGroup + '/' + vehicleReference + '/' + photoReference;
    return this.http.post<T>(url, file, this.getRequestHeadersFileUpload()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadPhotoEndpoint(productGroup, vehicleReference, photoReference, file));
      }));
  }

  getOfferListProductPhotoEndpoint<T>(id: string): Observable<T> {
    let endpointUrl = `${this.offerListProductPhotoUrl}/${id}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getOfferListProductPhotoEndpoint(id));
      }));
  }

  getDeleteCompanyEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.deleteCompanyUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDeleteCompanyEndpoint(userObject));
      }));
  }

  getAuditLoginListEndpoint<T>(userName: string, initialDate: string, finalDate: string): Observable<T> {
    let endpointUrl = `${this.auditLoginListUrl}/${userName}&${initialDate}&${finalDate}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getAuditLoginListEndpoint(userName, initialDate, finalDate));
      }));
  }

  cloneOfferEndpoint<T>(userObject: any): Observable<T> {
    return this.http.post<T>(this.cloneOfferUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.cloneOfferEndpoint(userObject));
      }));
  }

}
